<label *ngIf="_label" class="d-flex align-items-center gap-2 mb-2">
  <h3 class="mb-0 fw-bold" [ngClass]="labelColor">{{ _label }}
    <span *ngIf="required" class="text-danger">*</span>
  </h3>
  <fpc-button *ngIf="_popoverText" [buttonLayoutType]="'popover'" [buttonColorClass]="'primary'" [popoverText]="_popoverText" [text]="'This is a popover'"
    [iconSize]="iconSize" [placement]="'top'"></fpc-button>
</label>
<ng-content></ng-content>